export default __webpack_public_path__ + "static/media/pen-instore-background.6dc0e662.jpg";